export const paymentCardInfo = {
	payment: "Pago",
	cashPayment: "Al contado",
	installmentsPayment: "En cuotas",
};
